import React, { AnchorHTMLAttributes, useState } from 'react';
import { Link } from "react-router-dom";
import {LucideGem, LucideMoon, LucideSun, LucideShoppingCart, LucideTrash2, User} from "lucide-react";
import {CreditPackageData, CreditPricingModal} from "../modals/CreditPricingModal";
import { CheckoutModal } from '../modals/CheckoutModal';
import { InlineSearchBar } from "../common/InlineSearchBar";
import { DropdownMenu, DropdownMenuItems } from "../common/DropDownMenu";
import { AccountLoginModal } from "../modals/AccountLoginModal";
import { cn } from "../../lib/Utils";
import { RoundBadge } from "../common/RoundBadge";
import {Button} from "../ui/Button";
import {Typography} from "../ui/Typography";
import {useCart} from "../../context/CartContext";
import {useCreditModal} from "../../context/CreditModalContext";


export const AppHeader = (props: any) => {
    
    const [isAccountModalOpen, setAccountModal] = useState(false);
    const openAccountModal = () => {
        setAccountModal(true);
    };
    const closeAccountModal = () => {
        setAccountModal(false);
    };
    
    const itemsInCart = 2;

    return (
        <header
            className="sticky top-0 z-40 flex h-[72px] items-center justify-between border-b border-surface-200 
            dark:border-surface-800 bg-surface-50/80 dark:bg-surface-950/85 px-4 sm:px-6 lg:px-8 
            backdrop-blur-sm transition-colors duration-300">

            <div className="flex items-center gap-8 flex-grow">
                <Logo />
                <InlineSearchBar />
            </div>

            <div className="flex items-center gap-4 h-full">
                <nav className="flex items-center gap-4 text-sm font-medium mr-3 h-full">

                    <div className="w-px h-6 bg-surface-200 dark:bg-surface-800 hidden lg:block" /> 

                    <CartButton href="/cart" hasNotification={itemsInCart > 0} />
                </nav>

                <BuyCreditsModalButton />

                <div className="relative">
                    <DropdownMenu
                        trigger={<UserAvatar />}
                        position="right"
                    >
                        <DropdownMenuItems onOpenAccountModal={openAccountModal} />
                    </DropdownMenu>
                </div>

                <AccountLoginModal
                    isOpen={isAccountModalOpen}
                    onClose={closeAccountModal}
                />

            </div>
            
        </header>
    );
};


export const UserAvatar = () => {
    return (
        <button id="user-menu-button">
            <img
                src="https://placehold.co/32x32/111314/E3E6E8?text=L"
                alt="User avatar"
                className="w-8 h-8 rounded-full border-2 border-brand-500 hover:border-brand-500 transition-colors"
            />
        </button>
    );
};

const BuyCreditsModalButton = () => {
    const {openModal} = useCreditModal();
    const creditsOwned = 0;

    return (
        <a
            onClick={() => openModal()}
            className="flex items-center gap-2 text-sm font-medium px-3 py-1.5 rounded-md border 
              border-surface-800 hover:bg-gray-100 dark:hover:bg-surface-900 transition-colors min-w-[128px]"
        >
            <LucideGem className="text-base text-brand-500" size="20px"/>

            {creditsOwned > 0 ? (
                <>
                    <Typography as="p" variant="p" className="font-bold">{creditsOwned}</Typography>
                    <Typography as="p" variant="p" className="hidden sm:inline"> credits</Typography>
                </>
            ) : (
                <Typography as="p" variant="p" className="hidden sm:inline">No credits</Typography>
            )}
        </a>
    );
};


interface CartButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    itemCount?: number;
    hasNotification?: boolean;
}


export const CartButton = ({itemCount = 3, className, hasNotification, ...props}: CartButtonProps) => {
    {/*the styles at HomePage should change based on isCartSideBarOpen*/}
    const {isCartSideBarOpen, setIsCartSideBarOpen, toggleCartSidebar} = useCart();
    
    return (
        <>
            <Button 
                intent="link" 
                size="large"
                onClick={() => toggleCartSidebar()}
                className={isCartSideBarOpen ? cn("relative mr-5 flex items-center justify-center h-full w-[64px] " +
                    "bg-surface-800 hover:bg-surface-700 transition-colors border-l border-surface-700") : ""}
            >
                <LucideShoppingCart 
                    className={isCartSideBarOpen ? "text-surface-200": "text-surface-400"}
                >
                    {itemCount > 0 && (
                        <RoundBadge
                            amount={itemCount}
                            className="absolute top-0 right-0 h-4 text-xs transform translate-x-1/3 -translate-y-1/3"
                        />
                    )}
                </LucideShoppingCart>
            </Button>
        </>
    );
};


const Logo = (props: any) => {
    return (
        <Link
            to={"/"}
            className="flex items-center text-[22px] font-bold text-surface-950 dark:text-surface-50"
        >
            <span className="text-brand-400">icon</span>
            <span className="text-brand-50">.</span>
        </Link>
    );
};





